<template>
  <div class="menu-box" ref="menuBox" v-if="is_Work" :key="tabIndex">
    <el-menu
      :default-active="activate"
      class="el-menu-vertical-demo"
      :collapse="GET_STATUS"
      :unique-opened="true"
      ref="menu"
    >
      <template v-if="is_Menu">
        <el-tabs
          v-model="activeName"
          class="menu-tabs"
          @tab-click="handleMenuClick"
        >
          <el-tab-pane
            v-for="(item, index) in currentMenus"
            :label="item.name"
            :name="index + ''"
            :key="index"
          >
            <template v-for="chi in item.menuDtos">
              <template v-if="!chi.menuDtos.length">
                <el-menu-item
                  :index="chi.menuUrl"
                  @click="menuClick(chi)"
                  class="menu-menus"
                  :key="chi.menuUrl"
                >
                  <i :class="['iconfont', chi.icon, 'icon']"></i>
                  <el-tooltip
                    :disabled="chi.name.length <= 7"
                    effect="dark"
                    :content="chi.name"
                    placement="top"
                    :enterable="false"
                  >
                    <span>
                      <span class="item-leaf"> {{ chi.pardName }}</span>
                      <span v-if="chi.chidName" class="child-name">{{
                        chi.chidName
                      }}</span>
                    </span>
                  </el-tooltip>

                  <!-- {{ chi.name }} --></el-menu-item
                >
              </template>
              <template v-else>
                <el-submenu
                  :index="chi.menuUrl"
                  :key="chi.menuUrl"
                  :popper-append-to-body="false"
                >
                  <span slot="title"
                    ><el-tooltip
                      :disabled="chi.name.length <= 7"
                      effect="dark"
                      :content="chi.name"
                      placement="top"
                      :enterable="false"
                    >
                      <span>
                        <span class="item-leaf"> {{ chi.pardName }}</span>
                        <span v-if="chi.chidName" class="child-name">{{
                          chi.chidName
                        }}</span></span
                      >
                    </el-tooltip></span
                  >
                  <!-- THREE -->
                  <template>
                    <el-menu-item
                      v-for="leaf in chi.menuDtos"
                      :index="leaf.menuUrl"
                      :key="leaf.menuUrl"
                      @click="menuClick(leaf)"
                      ><el-tooltip
                        :disabled="leaf.name.length <= 7"
                        effect="dark"
                        :content="leaf.name"
                        placement="top"
                        :enterable="false"
                      >
                        <span>
                          <span class="item-leaf"> {{ leaf.pardName }} </span>
                          <span v-if="leaf.chidName" class="child-name">{{
                            leaf.chidName
                          }}</span></span
                        >
                      </el-tooltip></el-menu-item
                    >
                  </template>
                </el-submenu>
              </template>
            </template>
          </el-tab-pane>
        </el-tabs>
      </template>
      <template v-else>
        <template v-for="item in currentMenus">
          <el-submenu
            :index="item.menuUrl"
            v-if="item.menuDtos.length"
            :popper-append-to-body="false"
            :key="item.menuUrl"
          >
            <template slot="title">
              <i :class="['iconfont', item.icon, 'icon']"></i>
              <el-tooltip
                :disabled="item.name.length <= 7"
                class="item"
                effect="dark"
                :content="item.name"
                placement="top"
                :enterable="false"
              >
                <span>{{ item.name }}</span>
              </el-tooltip>
            </template>
            <!-- TOW -->
            <template v-for="chi in item.menuDtos">
              <template v-if="!chi.menuDtos.length">
                <el-menu-item
                  :index="chi.menuUrl"
                  @click="menuClick(chi)"
                  :key="chi.menuUrl"
                  class="menu-menus"
                >
                  <i :class="['iconfont', chi.icon, 'icon']"></i>
                  <el-tooltip
                    :disabled="chi.name.length <= 7"
                    effect="dark"
                    :content="chi.name"
                    placement="top"
                    :enterable="false"
                  >
                    <span>
                      <span class="item-leaf"> {{ chi.pardName }}</span>
                      <span v-if="chi.chidName" class="child-name">{{
                        chi.chidName
                      }}</span>
                    </span>
                  </el-tooltip>

                  <!-- {{ chi.name }} --></el-menu-item
                >
              </template>
              <template v-else>
                <el-submenu
                  :index="chi.menuUrl"
                  :key="chi.menuUrl"
                  :popper-append-to-body="false"
                >
                  <span slot="title"
                    ><el-tooltip
                      :disabled="chi.name.length <= 7"
                      effect="dark"
                      :content="chi.name"
                      placement="top"
                      :enterable="false"
                    >
                      <span>
                        <span class="item-leaf"> {{ chi.pardName }}</span>
                        <span v-if="chi.chidName" class="child-name">{{
                          chi.chidName
                        }}</span></span
                      >
                    </el-tooltip></span
                  >
                  <!-- THREE -->
                  <template>
                    <el-menu-item
                      v-for="leaf in chi.menuDtos"
                      :index="leaf.menuUrl"
                      :key="leaf.menuUrl"
                      @click="menuClick(leaf)"
                      ><el-tooltip
                        :disabled="leaf.name.length <= 7"
                        effect="dark"
                        :content="leaf.name"
                        placement="top"
                        :enterable="false"
                      >
                        <span>
                          <span class="item-leaf"> {{ leaf.pardName }} </span>
                          <span v-if="leaf.chidName" class="child-name">{{
                            leaf.chidName
                          }}</span></span
                        >
                      </el-tooltip></el-menu-item
                    >
                  </template>
                </el-submenu>
              </template>
            </template>
          </el-submenu>
          <template v-else>
            <el-menu-item
              :index="item.menuUrl"
              :key="item.menuUrl"
              @click="menuClick(item)"
            >
              <i :class="['iconfont', item.icon, 'icon']"></i>
              <el-tooltip
                :disabled="item.name.length <= 7"
                effect="dark"
                placement="top"
                :content="item.name"
                :enterable="false"
              >
                <span>
                  <span class="item-leaf">{{ item.pardName }}</span>
                  <span v-if="item.chidName" class="child-name">{{
                    item.chidName
                  }}</span></span
                >
              </el-tooltip>
            </el-menu-item>
          </template>
        </template>
      </template>
    </el-menu>
    <div class="is-collapse" @click="anIsUp">
      <i
        :class="[
          isCollapse ? 'icon-toggle-right' : 'icon-toggle-left',
          'icon',
          'iconfont',
        ]"
      ></i>
      <span class="is-collapse-font">收起</span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import common from "@/common/js/index.js";
export default {
  data() {
    return {
      activate: "",
      current: "",
      isCollapse: localStorage.getItem("isCollapse") == "true" ? true : false,
      time: null,
      tabIndex: 0,
      currentMenus: [],
      activeName: "0",
    };
  },
  computed: {
    ...mapGetters(["is_Work"]),
    ...mapGetters(["is_Menu"]),
    ...mapGetters(["GET_STATUS"]),
    ...mapGetters(["GET_LEFT_MENU"]),
    ...mapGetters(["GET_TAGLIST"]),
    ...mapGetters(["GET_ACTIVATE"]),
    ...mapGetters(["GET_MENU_LIST"]),
  },
  watch: {
    "$store.state.activate": {
      immediate: true,
      handler(val, old) {
        if (val == "clear") return;
        if (val?.indexOf("baseIsHistory") > -1) {
          this.isHistory = true;
          val = val.replace("baseIsHistory", "");
        }
        if (old?.indexOf("baseIsHistory") > -1) {
          this.isHistory = true;
          old = old.replace("baseIsHistory", "");
        }
        let obj = {
          flag: false,
        };
        this.locationMenu(val, this.GET_MENU_LIST, obj);
        let url = obj.flag ? val : old;
        url = url || this.$route.fullPath.substring(1).replace("#/", "/") || "";
        this.current = url;
        //带参数的路由选中this.activate = url?.split("?")[0] || "";
        //this.activate = url?.split("?")[0] || "";
        this.activate = this.delUrlByName(url, "time") || "";
        //处理资源管理菜单路由刷新和切换
        // if (this.is_Menu) {
        //   if (url.indexOf("jxjy-resource-web/schoolResource") > -1) {
        //     this.activeName = "1";
        //   }
        //   if (url.indexOf("jxjy-resource-web/myResource") > -1) {
        //     this.activeName = "0";
        //   }
        // }
      },
    },
    GET_LEFT_MENU: {
      immediate: true,
      handler(val) {
        let url = this.$route.fullPath.substring(1).replace("#/", "/");
        let arr = common.utils.inUrlGetId(url?.split("?")[0]);
        if (arr && arr.length) {
          arr?.map((v) => {
            if (v.secondaryMenuDtos) {
              v.secondaryMenuDtos?.map((item) => {
                //带参数的路由选中item.menuUrl == url?.split("?")[0]
                if (item.menuUrl?.split("?")?.[0] == url?.split("?")?.[0]) {
                  this.activate = v.menuUrl;
                }
              });
            }
          });
        }
        this.tabIndex += 1;
        this.currentMenus = val.filter((e) => e.isShow == 1);
        this.currentMenus?.map((item) => {
          item.chidName = item.name.split("-")[1];
          item.pardName = item.name.split("-")[0];
          item.menuDtos = item.menuDtos.filter((e) => e.isShow == 1);
          if (item.menuDtos && item.menuDtos.length) {
            this.nameSeconde(item.menuDtos);
          }
        });
      },
    },
  },
  created() {},
  mounted() {},
  methods: {
    //删除路由time参数
    delUrlByName(url, name) {
      if (!url) {
        return "";
      }
      var baseUrl = url.split("?")[0];
      var query = url.split("?")[1];
      if (!query) {
        return url;
      }
      if (url.indexOf(name) > -1) {
        var obj = {};
        var arr = query.indexOf("&") > -1 ? query.split("&") : [query]; //根据&分割，这里的service是unicode编码过得，不存在内部出现&的情况（会被转义成%）
        for (var i = 0; i < arr.length; i++) {
          arr[i] = arr[i].split("=");
          obj[arr[i][0]] = arr[i][1];
        }
        delete obj[name];
        let str = JSON.stringify(obj) === "{}" ? "" : "?";
        var url =
          baseUrl +
          str +
          JSON.stringify(obj)
            .replace(/[\"\{\}]/g, "")
            .replace(/\:/g, "=")
            .replace(/\,/g, "&");
        return url;
      } else {
        return url;
      }
    },
    handleMenuClick(tab) {
      this.menuClick(this.currentMenus[this.activeName]?.menuDtos?.[0]);
    },
    //处理菜单- 后面的数据
    nameSeconde(item) {
      item.map((nameDate) => {
        nameDate.chidName = nameDate.name.split("-")[1];
        nameDate.pardName = nameDate.name.split("-")[0];
        nameDate.menuDtos = nameDate.menuDtos.filter((e) => e.isShow == 1);
        if (nameDate.menuDtos && nameDate.menuDtos.length) {
          this.nameSeconde(nameDate.menuDtos);
        }
      });
    },
    // 递归查询当前的路由地址是否在返回的菜单列表中，如果在则定位，否则使用老定位
    // 主要解决跳到二级页面后，menu不定位到当前菜单
    locationMenu(val, list, obj) {
      list?.map((v) => {
        if (v.menuDtos?.length) {
          this.locationMenu(val, v.menuDtos, obj);
        }
        if (v.menuUrl == val) {
          obj.flag = true;
        }
      });
    },
    anIsUp() {
      this.isCollapse = !this.isCollapse;
      this.$store.commit("menuChange", this.isCollapse);
    },
    menuClick(item, type) {
      this.$store.commit("activateChange", {
        activate: "clear",
      });
      if (type == 1) {
        // 切换顶部菜单置空current，避免重复
        this.current = "";
      }
      this.getObtainLoginUserInformation();

      this.$nextTick(() => {
        var strRegex = /^https?:\/\//;

        if (strRegex.test(item.menuUrl)) {
          // 如果单击的是外部链接则打开新页面
          window.open(item.menuUrl);
          this.$nextTick(() => {
            this.$refs.menu.activeIndex = this.activate;
          });
          return;
        }
        if (item.showStyle == 0) {
          // 第一次之后的菜单 单击
          /* 菜单第二次之后的点击都是刷新子模块 */
          /* if (this.current == item.menuUrl) {
            this.$store.commit("refreshApp");
            return;
          } */
          let arr = item.menuUrl.split("/");
          if ("/" + arr[0] != this.$route.path) {
            this.$router.push({
              path: "/" + arr[0],
            });
          }
          // Start 解决 ones #825
          /* let url = location.href.replace("#/", "/").split("/app/") || [];
          if (url[1] == item.menuUrl) {
            this.current = item.menuUrl;
            return;
          } */
          // End
          this.$store.commit("activateChange", {
            activate: item.menuUrl,
          });
          this.current = item.menuUrl;
        } else {
          this.current = null;
          let arr = item.menuUrl.split("/");
          let routeData = this.$router.resolve({
            path: "/noFrame/" + arr[0] + "#/" + arr.slice(1).join("/"),
          });
          this.$store.commit("noFrameActivateChange", {
            activate: item.menuUrl,
          });
          window.open(routeData.href, "_blank");
          this.$nextTick(() => {
            this.$refs.menu.activeIndex = this.activate;
          });
          this.getObtainLoginUserInformation();
        }
      });
    },
    getObtainLoginUserInformation() {
      let userInfor = JSON.parse(localStorage.getItem("user"));
      let userTypeList = JSON.parse(localStorage.getItem("userType"));
      console.log(userTypeList, "userTypeuserTypeuserType");
      console.log(userInfor, "userInforuserInforuserInfor");
      let userName = "",
        schoolCode = "",
        campuszoneId = "",
        userType = "",
        classId = "",
        times = Date.now();
      if (userTypeList[0].userType == 1) {
        console.log("管理员");
        schoolCode = userTypeList[0].userIdentity[0].id;
        userName = userTypeList[0].userIdentity[0].userId;
        userType = userTypeList[0].userType;
      } else if (userTypeList[0].userType == 4) {
        console.log("学生");
        schoolCode = userTypeList[0].userIdentity[0].schoolId;
        userName = userTypeList[0].userIdentity[0].userId;
        userType = userTypeList[0].userType;
        campuszoneId = userTypeList[0].userIdentity[0].teachingPointId;
        classId = userTypeList[0].userIdentity[0].classId;
      } else if (userTypeList[0].userType == 3) {
        console.log("教师");
        schoolCode = userTypeList[0].userIdentity[0].id;
        userName = userTypeList[0].userIdentity[0].userId;
        userType = userTypeList[0].userType;
      } else if (userTypeList[0].userType == 2) {
        console.log("子管理员");
        schoolCode = userTypeList[0].userIdentity[0].id;
        userName = userTypeList[0].userIdentity[0].userId;
        userType = userTypeList[0].userType;
      } else if (userTypeList[0].userType == 0) {
        return false;
      }
      console.log(userName, schoolCode, "userNameschoolCodeuserNameschoolCode");

      // 动态创建 script 标签
      const script = document.createElement("script");
      script.type = "text/javascript";
      // https://onlineanalytics.ahjxjy.cn
      // http://jxjy.local/onlines
      script.src = `https://onlineanalytics.ahjxjy.cn/boot.js?userName=${userName}&userType=${userType}&schoolCode=${schoolCode}&campuszoneId=${campuszoneId}&classId=${classId}&_=${times}`;

      // 可选：监听脚本加载完成/失败事件
      script.onload = () => {
        console.log("脚本加载并执行成功");
      };
      script.onerror = (err) => {
        console.error("脚本加载失败", err);
      };

      // 将脚本插入到 body 或当前组件容器中
      document.body.appendChild(script);
      // 或插入到当前组件的 DOM 中：this.$el.appendChild(script)
    },
  },
};
</script>

<style lang="scss" scoped>
.menu-box {
  padding-top: 10px;
  position: relative;
  height: calc(100vh - 90px);
}
::v-deep .is-active {
  color: var(--primary) !important;
  background: #f3f5fc !important;
}

::v-deep .el-menu--inline {
  .is-active:not(.is-opened) {
    background: #f3f5fc !important;
  }
}

::v-deep .el-menu-vertical-demo {
  height: calc(100vh - 150px) !important;
}
.el-menu {
  border: 0 !important;
}
::v-deep .el-submenu.is-active .el-submenu__title {
  background: #fff !important;
}
::v-deep .el-menu:not(.el-menu--inline, .el-menu--collapse) {
  box-sizing: border-box;
}
::v-deep .el-menu-vertical-demo {
  padding: 0 20px !important;
}
::v-deep .el-menu:not(.el-menu--collapse) {
  border: none !important;
  span {
    font-family: SourceHanSansCN, SourceHanSansCN;
    font-weight: 500;
    font-size: 16px;
    color: #585d69;
  }
  .child-name {
    font-size: 12px;
    color: #a4a8b0 !important;
    margin-left: 5px;
  }
  .el-menu--inline {
    .is-active.el-menu-item {
      .item-leaf {
        color: var(--primary) !important;
      }
    }
  }

  /*  .el-menu-item {
    color: #585d69 !important;
  } */
  i {
    color: #181818 !important;
    font-weight: 400 !important;
  }
  i:not(.iconfont) {
    color: #a4a8b0 !important;
    font-size: 15px !important;
    right: 3px !important;
  }
  i:not(.el-icon-arrow-down) {
    color: #a4a8b0 !important;
    margin-right: 6px;
  }
  .el-submenu {
    border-radius: 4px !important;
  }
  .el-submenu__title {
    height: 40px !important;
    line-height: 40px !important;
    padding: 0 !important;
  }
  .el-menu--inline {
    .el-submenu__title {
      padding-left: 50px !important;
    }
  }
  .el-menu-item {
    height: 40px !important;
    line-height: 40px !important;
    padding-left: 40px !important;
    border-radius: 4px;
    min-width: 180px !important;
  }
}
::v-deep .el-submenu__title {
  font-weight: bold;
  border-radius: 4px !important;
}
.el-menu-vertical-demo:not(.el-menu--collapse)::-webkit-scrollbar {
  height: 0px;
  width: 0px;
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 240px;
  min-height: 400px;
  overflow-y: auto;
}
::v-deep .el-menu--vertical {
  position: fixed !important;
  padding: 0 !important;
}
.icon {
  margin-right: 10px;
  width: 20px;
  text-align: center;
  font-size: 20px;
  vertical-align: middle;
}
.is-collapse {
  cursor: pointer;
  position: absolute;
  bottom: 0;
  border-top: 1px solid #e3e2ec;
  z-index: 2000 !important;
  display: flex;
  align-items: center;
  overflow: hidden;
  width: 100%;
  background: #fff;
  z-index: 9;
  i {
    margin-right: 0 !important;
    border-radius: 50%;
    font-weight: 200;
    font-size: 19px;
    color: #a4a8b0;
    width: 64px;
    height: 49px;
    overflow: hidden;
    display: inline-block;
    line-height: 49px;
  }
  .is-collapse-font {
    flex: 1;
    white-space: nowrap;
    overflow: hidden;
  }
}
::v-deep .el-icon-arrow-down::before {
  content: "\e790" !important;
}
::v-deep .el-menu-item:hover {
  background: #f3f5fc !important;
}
::v-deep .el-menu--inline {
  .el-submenu {
    .el-menu--inline {
      .el-menu-item {
        padding-left: 65px !important;
      }
    }
  }
}

::v-deep .el-menu--collapse.el-menu {
  padding: 0 !important;
  i {
    color: #a4a8b0 !important;
    font-weight: 400 !important;
  }
  .el-submenu__title,
  .el-menu-item {
    height: 40px !important;
    line-height: 38px !important;
  }

  .el-menu-item {
    padding: 0 20px !important;
  }
  .el-submenu__title {
    font-weight: 400 !important;
  }
  .el-icon-arrow-right::before {
    content: "\e790";
  }
  .is-active {
    .el-submenu__title {
      background: #f3f5fc !important;
    }
  }
  .el-submenu__title:hover {
    background: #f3f5fc !important;
  }
}

::v-deep .el-menu-item,
.el-submenu__title {
  .el-tooltip {
    display: inline-block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
    width: 125px !important;
  }
}
::v-deep .el-menu-vertical-demo:not(.el-menu--collapse) > .el-menu-item {
  padding: 0 20px 0 10px !important;
  font-weight: bold;
}
//::v-deep
//   .el-menu-vertical-demo:not(.el-menu--collapse)
//   > .el-menu-item:nth-child(n + 2):nth-child(-n + 8) {
//   padding-left: 29px !important; /* 从第二个 li 开始添加 padding */
// }
.el-menu:not(.el-menu--collapse) {
  .el-menu-item.is-active {
    // span {
    //   color: var(--primary) !important;
    // }
  }
}
.el-menu--collapse + .is-collapse {
  .is-collapse-font {
    display: none;
  }
}
.is-collapse {
  overflow: hidden;
}
.is-collapse-font {
  font-size: 14px;
  color: #585d69;
  margin-bottom: 1px;
  margin-left: -15px;
}
::v-deep .el-submenu__title:hover {
  background: #f3f5fc !important;
}

::v-deep .is-active:not(.is-opened) {
  background: #f3f5fc !important;
  span {
    color: var(--primary) !important;
  }
  .el-submenu__title {
    span {
      color: #585d69 !important;
    }
  }
}

.menu-tabs {
  margin-top: 15px;
}
.menu-tabs::v-deep .el-tabs__nav {
  display: flex;
  justify-content: space-between;
  width: 200px;
}
.menu-tabs::v-deep .el-tabs__nav-wrap::after {
  background-color: transparent;
}
.menu-tabs::v-deep .el-tabs__item {
  font-family: SourceHanSansCN, SourceHanSansCN;
  font-weight: 400;
  font-size: 18px !important;
  color: #a4a8b0 !important;
  width: 72px;
  padding: 0 !important;
}
.menu-tabs::v-deep .el-tabs__item.is-active {
  background: transparent !important;
  font-family: SourceHanSansCN, SourceHanSansCN;
  font-weight: bold;
  color: #585d69 !important;
  border-bottom: 2px solid var(--primary);
}
.menu-tabs::v-deep .el-tabs__active-bar {
  display: none;
}
.menu-tabs::v-deep .el-tabs__content {
  margin-top: 16px;
}
.menu-menus {
  position: relative;
}
.menu-menus .iconfont {
  position: absolute;
  left: 5px;
  top: 0;
  width: 13px;
  height: 13px;
}
</style>
